import axios from './axios';
import { MediaSearchOrder } from './media';

export type UserRole = 'user' | 'moderator'

export interface UserResponse {
    isVerified: boolean;
    username: string;
    name: string;
    description: string;
    site: string;
    avatar: string;
    views: number;
}
export const getUser = (username: string) => {
    return axios.get<UserResponse>(`/users/slug/${username}`, {
        validateStatus: function (status) {
            return status == 200 || status == 404;
          }
    });
}


export interface UserSearchQuery {
    order?: MediaSearchOrder;
    
    count?: number;
  
    page?: number;
}

export type SearchUsersResponse = {
    users: UserResponse[];
    totalUsers: number;
}
export const searchUsers = (query: UserSearchQuery) => {
    return axios.get<SearchUsersResponse>(`users/search`, {
        params: query
    });
}

export interface MediaUser {
    username: string;
    name: string;
    isVerified: boolean;
    avatar: string;
}

export interface MediaTag {
    name: string;
    slug: string;
  }

export interface MediaInfo {
    duration?: number;
  
    enableAudio?: boolean;
  
    hasAudio?: boolean;
  
    width?: number;
  
    height?: number;
  
    isPaid: boolean;
  
    priceInCents: number;
  }

export interface MediaUrl {
    url: string;
    [renditionName: string]: string;
}
export interface MediaUrls {
    hd?: string;

    poster?: string;
  
    sd?: string;
}
export interface MediaListItem {
    createdAt: Date;
    slug: string;
    title?: string;
    mediaType: "photo" | "video" | "gallery";
    isTranscoding: boolean;
    isApproved: boolean;
    views: number;
    likes: number;
    user: MediaUser;
    urls: MediaUrls;
    info: MediaInfo;
    gallery?: string;
    tags: MediaTag[];
}
export const getUserMedia = (username: string) => {
    return axios.get<MediaListItem[]>(`/users/${username}/media`);
}